"use client"

import React from 'react'
import { useToast } from './use-toast'

export function ToastProvider({ children }: { children: React.ReactNode }) {
  const { toasts } = useToast()

  return (
    <>
      {children}
      <div className="fixed top-0 right-0 z-50 p-4 space-y-4">
        {toasts.map((toast, index) => (
          <div
            key={index}
            className={`p-4 rounded-md shadow-md transition-all transform translate-y-0 opacity-100 ${
              toast.variant === 'destructive' ? 'bg-red-100 text-red-900' : 'bg-white text-gray-900'
            }`}
          >
            <div className="font-medium">{toast.title}</div>
            {toast.description && <div className="text-sm mt-1">{toast.description}</div>}
          </div>
        ))}
      </div>
    </>
  )
}
